import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Usuario } from "@/shared/types/usuario";

export interface UsuarioAddRequest {
    email: string,
    password: string,
    nombre: string,
    numDocumento: string,
    telefono?: string,
    direccion?: string,
    organizacionId?: string,
    rol?: string,
}

export async function addUsuario(request: UsuarioAddRequest): Promise<Usuario> {
    await sleep(1000);
    const response = await api.post("usuarios", request);
    return response.data;
}

export function useAddUsuarioMutation(mutationConfig: MutationConfig<Usuario, UsuarioAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addUsuario,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["usuarios"] });
        },
    })
}

export interface AddUsuarioMutationProps {
    mutationConfig?: MutationConfig<Usuario, UsuarioAddRequest>
    children?: (mutationResult: MutationResult<Usuario, UsuarioAddRequest>) => ReactNode
}

export function AddUsuarioMutation({
    mutationConfig,
    children
}: AddUsuarioMutationProps) {
    const mutationResult = useAddUsuarioMutation(mutationConfig);
    return children && children(mutationResult);
}